import { Consent } from '@axo/form/feature/axo-form-v2/lib/components';
import { useTranslation } from '@axo/shared/i18n';
import { ButtonSet } from '@axo/ui-core/components/Button';
import { HighlightInfo } from '@axo/ui-feature/components/HighlightInfo';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from '../../../../../components/Form';
import { Navigation } from '../../../../../components/Navigation';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { useMarketingConsent } from '../../../../../hooks/useMarketingConsent';
import { Step5Data } from '../../../FormData.fi.types';
import { DebtFormGroup } from './DebtFormGroup';
import { LoanOverview } from './LoanOverview';
import { PurposeFormGroup } from './PurposeFormGroup';
import { RefinanceDebtFormGroup } from './RefinanceDebtFormGroup';
import { SavingAmount } from './SavingAmount';

export const Step5 = () => {
  const { t } = useTranslation();

  const { onChange, onPrevStep, onSubmit, axoFormData } =
    useAxoFormContext<Step5Data>();

  const form = useForm({
    mode: 'onBlur',
  });

  const {
    formState: { isSubmitting, touchedFields },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  const { showMarketingConsent = true } = useMarketingConsent({
    marketingConsent: axoFormData['Ignore/MarketingConsent'],
    shouldShowMarketingConsent: axoFormData['Ignore/ShowMarketingConsent'],
  });

  return (
    <FormProvider {...form}>
      <Form onSubmit={onSubmit} onChange={onChange}>
        <HighlightInfo
          title={t('SavingsAmount.title')}
          description={t('SavingsAmount.description')}
        />

        <RefinanceDebtFormGroup />

        <SavingAmount />

        <LoanOverview />

        <DebtFormGroup />

        <PurposeFormGroup />

        <Consent showMarketingConsent={showMarketingConsent}>
          <Consent.TermsAndConditions />
          <Consent.Marketing />
        </Consent>

        <ButtonSet justify={'space-between'} responsive>
          <Navigation.Back onClick={onPrevStep}>{t('back')}</Navigation.Back>
          <Navigation.Continue loading={isSubmitting}>
            {t('next')}
          </Navigation.Continue>
        </ButtonSet>
      </Form>
    </FormProvider>
  );
};
